let printingInProgress = false;

export function sendToPrinter(printerName, rawData) {
  
  console.log('sendToPrinter entered', printerName);

  if (!window.qz) {
    console.error('QZ Tray not available');
    return;
  }

  if (!printerName) {
    console.error('Printer name missing');
    return;
  }

  if (printingInProgress) {
    console.warn('Print already in progress, skipping');
    return;
  }

  printingInProgress = true;

  const qz = window.qz;

  // ✅ DO NOT set encoding for RAW binary
  const config = qz.configs.create(printerName, {
    copies: 1
  });

  qz.print(config, [{
    type: 'raw',
    data: rawData
  }])
  .then(() => {
    console.log('Print job sent to QZ');
  })
  .catch(err => {
    console.error('QZ print failed', err);
  })
  .finally(() => {
    printingInProgress = false;
  });
}
